import { memo } from 'react';
import { NodeProps } from 'reactflow';
import { BaseNode } from './BaseNode';

export const TriggerNode = memo((props: NodeProps) => {
  const getDescription = () => {
    const config = props.data.config;
    const campaignType = props.data.campaignType;

    if (!config) {
      return 'Clique para configurar';
    }

    const lines = [];

    // Linha 1: Conexões (sempre mostrar)
    const line1Parts = [];
    if (config.connections?.length) {
      line1Parts.push(`🔌 ${config.connections.length} conexão(ões)`);
    } else {
      line1Parts.push('⚠️ Sem conexões');
    }

    // Para OUTBOUND: adicionar categorias na mesma linha
    if (campaignType === 'OUTBOUND') {
      if (config.categories?.length) {
        line1Parts.push(`📂 ${config.categories.length} cat.`);
      }
    }

    lines.push(line1Parts.join(' • '));

    // Linha 2: Configurações específicas
    const line2Parts = [];

    // Para INBOUND: Tipo de trigger
    if (campaignType === 'INBOUND') {
      const triggerType = config.triggerType || 'ANY_MESSAGE';
      if (triggerType === 'FIRST_MESSAGE') {
        line2Parts.push('👋 1ª Msg');
      } else if (triggerType === 'KEYWORD_EXACT') {
        const kwCount = config.keywords?.length || 0;
        line2Parts.push(`🎯 Exata: ${kwCount} palavra(s)`);
      } else if (triggerType === 'KEYWORD_CONTAINS') {
        const kwCount = config.keywords?.length || 0;
        line2Parts.push(`🔍 Contém: ${kwCount} palavra(s)`);
      } else {
        line2Parts.push('📢 Qualquer');
      }

      if (config.inactivityTimeout) {
        const warnIcon = config.warningEnabled ? '🔔' : '⏰';
        line2Parts.push(`${warnIcon} ${config.inactivityTimeout}min`);
      }

      if (config.stopCommands?.length) {
        line2Parts.push(`🛑 ${config.stopCommands.length} palavra(s) de parada`);
      }
    } else {
      // Para OUTBOUND (campanha interativa): tipo de agendamento + timeout de inatividade
      line2Parts.push(config.scheduleType === 'scheduled' ? '📅 Agendado' : '⚡ Imediato');
      if (config.inactivityTimeout) {
        const warnIcon = config.warningEnabled ? '🔔' : '⏰';
        line2Parts.push(`${warnIcon} ${config.inactivityTimeout}min`);
      }
    }

    if (line2Parts.length > 0) {
      lines.push(line2Parts.join(' • '));
    }

    return lines.join('\n');
  };

  return (
    <BaseNode
      {...props}
      icon="⚡"
      label="Início"
      color="#8ad0f3"
      description={getDescription()}
      onDelete={props.data.onDelete}
    />
  );
});

TriggerNode.displayName = 'TriggerNode';
